import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        input: {
            textAlign: 'right',
            '& > p': {
                display: 'none',
            },
            '& input': {
                textAlign: 'right',
            },
        },
        red: {
            '&&': {
                color: theme.palette.common.red,
            },
        },
        green: {
            '&&': {
                color: theme.palette.common.green,
            },
        },
    }
})

export default useStyles
